import { Input } from "ant-design-vue";
import lodash from "lodash";
import {
    createFieldInput,
    createFieldInputNumber,
    createFieldSelect,
    createFieldTextArea
} from "../../../../../components/input/template-builder/template-builder.logic";
import {
    createColumnInput,
    createColumnInputNumber,
    createColumnSelect
} from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import store from "../../../../../store";
import { conditionFormChecker, putField } from "../../../../../utils/form";

export const callLookup = ({ group, searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", {
        group,
        where: [
            { name: "key", operator: "like", value: searchQuery },
            { logic: "OR", name: "value", operator: "like", value: searchQuery }
        ],
        options: { force: true }
    });

export const createColumns = ({ group }) => {
    const columns = [
        createColumnSelect({
            title: () => i18n.global.t("model.lookup.refParent"),
            dataIndex: "refParent.id",
            customRender: ({ record }) => (
                <div>
                    {record.refParent?.key} {record.refParent?.value}
                </div>
            ),
            inputProp: () => ({
                list: ({ searchQuery }) => callLookup({ group, searchQuery }),
                renderLabel: ({ item }) => (
                    <div>
                        {item.key} {item.value}
                    </div>
                )
            })
        }),
        createColumnInput({ title: () => i18n.global.t("model.lookup.key"), dataIndex: "key" }),
        createColumnInput({ title: () => i18n.global.t("model.lookup.value"), dataIndex: "value" }),
        createColumnInput({ title: () => i18n.global.t("model.lookup.value2"), dataIndex: "value2" }),
        createColumnInputNumber({ title: () => i18n.global.t("model.lookup.seq"), dataIndex: "seq" })
    ];
    return columns;
};

export const createColumnsForIconList = () => {
    const columns = [
        createColumnInput({
            dataIndex: "key",
            search: {
                field: {
                    colProp: () => ({ xs: 24 }),
                    formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
                    inputRender: ({ field }) => {
                        return (
                            <Input.Search
                                value={field.searchValue}
                                onUpdate:value={value => (field.searchValue = value)}
                                placeholder={i18n.global.t("button.search")}
                            ></Input.Search>
                        );
                    }
                }
            }
        })
    ];
    return columns;
};

export const createField = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refParent`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.lookup.refParent"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refParent,
                            "onUpdate:value": value => {
                                model.refParent = value;
                            },
                            disabled: viewOnly,
                            // list ===> condition.js
                            // renderLabel ===> condition.js
                            allowClear: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}key`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.lookup.key"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        { value: model.key, "onUpdate:value": value => (model.key = value), disabled: viewOnly },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}value`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.lookup.value"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        { value: model.value, "onUpdate:value": value => (model.value = value), disabled: viewOnly },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}value2`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.lookup.value2"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        { value: model.value2, "onUpdate:value": value => (model.value2 = value), disabled: viewOnly },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}seq`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.lookup.seq"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        { value: model.seq, "onUpdate:value": value => (model.seq = value), disabled: viewOnly },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}attributeStr`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.department.attribute"),
                inputProp: ({ field }) => {
                    const onBlur = () => {
                        try {
                            model.attribute = JSON.parse(model.attributeStr);
                            model.attributeStr = JSON.stringify(model.attribute, null, 4);
                        } catch (error) {
                            error;
                        }
                        useForm.validate("attributeStr").catch(() => {});
                    };
                    return lodash.merge(
                        {
                            value: model.attributeStr,
                            "onUpdate:value": value => (model.attributeStr = value),
                            rows: 6,
                            autoSize: false,
                            onBlur,
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                }
            })
        ]
    });
};
